var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58329 2.75H19.4166C20.3371 2.75 21.0833 3.57081 21.0833 4.58333V15.5833C21.0833 16.5959 20.3371 17.4167 19.4166 17.4167H2.58329C1.66282 17.4167 0.916626 16.5959 0.916626 15.5833V4.58333C0.916626 3.57081 1.66282 2.75 2.58329 2.75ZM2.74996 9.16667V15.5833H19.25V9.16667H2.74996ZM2.74996 7.33333H19.25V4.58333H2.74996V7.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.9a34dab87d9e56fbe7f77c292974bca7.svg";
export { ForwardRef as ReactComponent };